import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { MONDAY } from 'utils/rest';

import { Text } from 'components/DataDisplay';
import { Modal } from 'components/Feedback';
import { FormSection } from 'components/FormSection';
import { Button } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';
import { ListField } from 'components/ListField';

const formatMapping = (mapping = []) => {
  return mapping.map(el => {
    return {
      columnId: el.columnId,
      key: el.key,
      label: el.label,
      type: el.type
    };
  });
};

export const UpdateForm = props => {
  const { config, onNext, onClose, availableMapping = [] } = props;

  const initialState = { mapping: [] };
  const configId = config._id;
  const configMapping = formatMapping(config.mapping);
  const [columns, setColumns] = useState([]);

  const selectMapping = availableMapping
    .map(el => {
      return { ...el, value: el.key, path: el.value };
    })
    .sort((a, b) => a.label.localeCompare(b.label));

  const [{ name, mapping, boardId }, setState] = useState({
    ...config,
    mapping: configMapping
  });

  const fetchDatas = async () => {
    const fetchedColumns = await MONDAY.getColumns(configId);
    if (fetchedColumns) {
      setColumns(
        fetchedColumns.map(({ id, title }) => {
          return { label: title, value: id };
        })
      );
    }
  };

  useEffect(() => {
    fetchDatas();
    // eslint-disable-next-line
  }, [configId]);

  const handleChange = key => value => {
    setState(prevState => {
      const states = { ...prevState };
      states[key] = value;
      return states;
    });
  };

  const resetStates = () => {
    setState(initialState);
  };

  const onValidate = async () => {
    const finalMapping = mapping.map(({ columnId, key }) => {
      const label = columns.find(el => el.value === columnId)?.label;
      const mappingElem = selectMapping.find(el => el.key === key);
      return { columnId, key, label, type: mappingElem?.type };
    });
    const data = { mapping: finalMapping };
    onNext(data);
    resetStates();
  };

  const getActions = () => {
    return (
      <Container>
        <Row spacing={1}>
          <Item xs justify="flex-end">
            <Button
              variant="contained"
              size="medium"
              widthSize="medium"
              onClick={onValidate}
            >
              Mettre à jour le board
            </Button>
          </Item>
        </Row>
      </Container>
    );
  };

  return (
    <Modal
      actions={getActions()}
      {...props}
      onClose={() => {
        resetStates();
        onClose();
      }}
    >
      <Container>
        <Row spacing={1}>
          <Item justify="flex-start">
            <FormSection title="Édition du board" xs={3}>
              <Container>
                <Row spacing={0} justify="flex-start">
                  <Item xs={12} justify="flex-start">
                    <Container>
                      <Row spacing={0} justify="flex-start">
                        <Item justify="flex-start">
                          <Text>
                            Board: {name} ({boardId})
                          </Text>
                        </Item>
                        <Item xs={11} justify="flex-start">
                          <ListField
                            labels={['Élément ERMES', 'Colonne Monday']}
                            values={mapping}
                            options={['key', 'columnId']}
                            onChange={handleChange('mapping')}
                            actionTxt="Ajouter un élément"
                            deleteAction
                            variant="customFields"
                            inputs={['Select', 'Select']}
                            fieldsFormat={[selectMapping, columns]}
                            isRequireds={[true, true]}
                            hideKeys={['type', 'label']}
                          />
                        </Item>
                      </Row>
                    </Container>
                  </Item>
                </Row>
              </Container>
            </FormSection>
          </Item>
        </Row>
      </Container>
    </Modal>
  );
};

UpdateForm.defaultProps = {
  onClose: () => null
};
UpdateForm.propTypes = {
  onNext: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  config: PropTypes.objectOf(PropTypes.any).isRequired
};

export default UpdateForm;
